import { isHomeMenuReachable } from "@/containers/AdminLayout/Sidebar/Menus/useNavigationModel";
import type { LoginInfo, LandingPagePage } from "@/types/LoginInfo";

type HashMapType = {
  [key in LandingPagePage]: string;
};

export const getHashFromLandingPage = (loginInfo: LoginInfo): string => {
  const _hashMap: HashMapType = {
    ASSET_LIST: "/tracked_assets",
    ASSET_MAP: "/assets_location",
    GEOZONE_DASHBOARD: "/geozones_dashboard",
    ACTIVE_ALERT_DASHBOARD: "/active_alerts_dashboard",
    REPORTS: "/reports",
    ORGANISATIONS: "/organization",
    TRACKER_ADMIN: "/trackers",
    SUEZ_DASHBOARD: "/suez_dashboard",
    DASHBOARD: "/bi_dashboard/",
  };

  if (loginInfo.landingPage && loginInfo.landingPage.page === "DASHBOARD") {
    let appliedFilterSettings = loginInfo.landingPage.appliedFilterSettings;
    if (typeof loginInfo.landingPage.appliedFilterSettings === "string") {
      appliedFilterSettings = JSON.parse(
        loginInfo.landingPage.appliedFilterSettings
      ) as { dashboardId: string };
    }
    const dashboardId = (appliedFilterSettings as { dashboardId?: string })
      ?.dashboardId;
    if (dashboardId) {
      return _hashMap["DASHBOARD"] + dashboardId;
    }
    return "/all_dashboards";
  }

  if (
    loginInfo.userPermissions &&
    loginInfo.userPermissions.includes("MANUFACTURING")
  ) {
    return "/manufacturing_info_view";
  } else if (loginInfo.landingPage && loginInfo.landingPage.page) {
    return _hashMap[loginInfo.landingPage.page];
  } else if (!isHomeMenuReachable(loginInfo)) {
    // No Home menu, so no Home path: a SYSTEM login (never has one) or a partner
    // without the legacy_partner_home_menu key (STIC-15365). Both land on the
    // organisation list. A partner WITH the key falls through to Home's asset
    // list, like a normal organisation.
    //
    // System used to fall through to /tracked_assets and be corrected later by
    // `SidebarBody`'s landing check — fine at login, but callers that push this
    // path directly (SidebarLogo) had no such correction.
    return "/organization";
  } else {
    return "/tracked_assets";
  }
};
